import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { NewWorkbookForDatasource } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface NewWorkbookForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newWorkbookForDatasource(contentInfo: IContentInfo): NewWorkbookForDatasourceAction {
  return {
    type: NewWorkbookForDatasource,
    contentInfo
  };
}

export const isNewWorkbookForDatasourceAction = isActionFactory<NewWorkbookForDatasourceAction>(NewWorkbookForDatasource);
